if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends HTMLElement {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.dataset.cartQuantity) === 0) {
            this.addToCart(event);
          } else {
            this.updateCart(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'quick-add') {
            return;
          }
          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      getInput() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.getInput().addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.getInput().addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.getInput().blur();
            this.isEnterPressed = true;
          }
        });
      }

      resetQuantityInput(id) {
        const input = document.getElementById(id);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      onCartUpdate() {
      return new Promise((resolve, reject) => {
        const wrapper = this.closest('.collection') || this.closest('.shopify-section');
        if (!wrapper) return resolve();
        fetch(`${this.getSectionsUrl()}?section_id=${wrapper.dataset.id}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector(
              `#quick-add-bulk-${this.dataset.id}-${wrapper.dataset.id}`
            );
            if (sourceQty) {
              this.innerHTML = sourceQty.innerHTML;
            }
            resolve();
          })
          .catch((e) => {
            console.error(e);
            reject(e);
          });
      });
    }

      updateCart(event) {
        this.lastActiveInputId = event.target.getAttribute('data-index');
        this.quantity.classList.add('quantity__input-disabled');
        this.selectProgressBar().classList.remove('hidden');
        const body = JSON.stringify({
          quantity: event.target.value,
          id: event.target.getAttribute('data-index'),
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig('javascript'), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.quantity.classList.remove('quantity__input-disabled');
            if (parsedState.description || parsedState.errors) {
              event.target.setCustomValidity(parsedState.description);
              event.target.reportValidity();
              this.resetQuantityInput(event.target.id);
              this.selectProgressBar().classList.add('hidden');
              event.target.select();
              this.cleanErrorMessageOnType(event);
              return;
            }

           this.renderSections(parsedState);

// ✅ Hide progress bar after successful update
this.selectProgressBar().classList.add('hidden');

publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });

          })
          .catch((error) => {
            console.log(error, 'error');
          });
      }

      addToCart(event) {
        this.quantity.classList.add('quantity__input-disabled');
        this.selectProgressBar().classList.remove('hidden');
        this.lastActiveInputId = event.target.getAttribute('data-index');
        const body = JSON.stringify({
          items: [
            {
              quantity: parseInt(event.target.value),
              id: parseInt(this.dataset.id),
            },
          ],
          sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.quantity.classList.remove('quantity__input-disabled');
            if (parsedState.description || parsedState.errors) {
              event.target.setCustomValidity(parsedState.description);
              event.target.reportValidity();
              this.resetQuantityInput(event.target.id);
              this.selectProgressBar().classList.add('hidden');
              event.target.select();
              this.cleanErrorMessageOnType(event);
              // Error handling
              return;
            }

            this.renderSections(parsedState);

// ✅ Hide progress bar after successful add
this.selectProgressBar().classList.add('hidden');


              fetch(`${routes.cart_url}.js`, { credentials: 'same-origin' })
                  .then((r) => r.json())
                  .then((liveCart) => {
                      const enriched = {
                          ...parsedState,
                          item_count: typeof liveCart?.item_count === 'number' ? liveCart.item_count : parsedState.item_count,
                          items: Array.isArray(liveCart?.items) ? liveCart.items : parsedState.items,
                          total_price: typeof liveCart?.total_price === 'number' ? liveCart.total_price : parsedState.total_price,
                      };
                      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: enriched });
                  })
                  .catch(() => {
                      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
                  });
          })
          .catch((error) => {
            console.error(error);
          });
      }

      getSectionsToRender() {
  const wrapper = this.closest('.collection-quick-add-bulk');

  // Grab the REAL Shopify section name from closest .shopify-section
const shopifySection = this.closest('.shopify-section'); 
const renderedSectionId = shopifySection?.id?.replace('shopify-section-', '');


  return [
        {
      id: `quick-add-bulk-${this.dataset.id}-${renderedSectionId}`,
      section: renderedSectionId,
      selector: `#quick-add-bulk-${this.dataset.id}-${renderedSectionId}`
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    },
    {
      id: 'CartDrawer',
      section: 'cart-drawer',
      selector: '#CartDrawer'
    }
  ];
}

      

      getSectionsUrl() {
        const url = window.location.href;
        const params = new URL(url);
        const searchParams = new URLSearchParams(params.search);

        const queryParams = {};
        searchParams.forEach((value, key) => {
          queryParams[key] = value;
        });

        const searchParamsString = searchParams.toString();

        if(searchParamsString){
            return `${window.location.pathname}?${searchParamsString}`;
        }
        
        if (window.pageNumber) {
          return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
            if(window.location.search){
                return `${window.location.pathname}/${window.location.search}`;
            } else {
                return `${window.location.pathname}`
            }

        }
      }

      getSectionInnerHTML(html, selector) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const found = doc.querySelector(selector);

  if (!found) {
    console.warn("⚠ Selector missing in section:", selector);
    return "";
  }

  return found.innerHTML;
}


renderSections(parsedState) {
  this.getSectionsToRender().forEach((section) => {
    const sectionElement = document.getElementById(section.id);

    if (!sectionElement) {
      console.warn("⚠ Missing section element:", section.id);
      return;
    }

    const elementToReplace =
      sectionElement.querySelector(section.selector) || sectionElement;

    const sectionHTML = parsedState?.sections?.[section.section];

    if (!sectionHTML) {
      console.warn("⚠ Missing section HTML in response:", section.section);
      return;
    }

    const newInnerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);

    if (!newInnerHTML) return;

    elementToReplace.innerHTML = newInnerHTML;

    // Drawer reopening logic (unchanged)
    if (sectionElement.parentElement?.classList.contains('drawer')) {
      parsedState.items.length > 0
        ? sectionElement.parentElement.classList.remove('is-empty')
        : sectionElement.parentElement.classList.add('is-empty');

      setTimeout(() => {
        document.querySelector('#cart-icon-bubble')?.click();

        const overlay = document.querySelector('#CartDrawer-Overlay');
        overlay?.addEventListener('click', (evt) => {
          const btnClose = document.querySelector('cart-drawer .drawer__close');
          if (evt.target === overlay) btnClose?.click();
        });
      });
    }
  });

  // re-bind inputs
  if (this.isEnterPressed) {
    this.querySelector(`#Quantity-${this.lastActiveInputId}`)?.select();
  }

  this.listenForActiveInput();
  this.listenForKeydown();
}

    }
  );
}
